export class DraftLegalDocumentRequest{
    public propertyId!:number;
    public userId!:string;
    public text!:string;
    public day!:string;
    public month!:string;
    public year!:string;
    public interactivePlaceholderContentList: InteractivePlaceholderContent[] = [];
    public watermark?:string;
}

export class InteractivePlaceholderContent{
    public placeholderName?:string;
    public placeholderContent?:string;
}